import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import BaseInputComponent from './BaseInputComponent.vue';
export default {
  extends: BaseInputComponent,
  props: {
    textarea: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: '+34'
    },
    size: {
      type: String,
      default: 'md'
    },
    variant: {
      type: String,
      default: 'default'
    },
    type: {
      type: String,
      default: 'text'
    },
    // Input type
    autofocus: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: undefined
    },
    // Min characters or num
    max: {
      type: Number,
      default: undefined
    },
    // Max characters or num
    allButton: Boolean,
    quickClean: Boolean
  },
  emits: ['update:prefix', 'focus', 'enter', 'input'],
  data: function () {
    return {
      focus: false,
      search: undefined,
      showPassword: false
    };
  },
  computed: {
    bindedInputFieldAttributes() {
      if (!this.isSelector) {
        return;
      }
      return {
        onfocus: this.onFocus,
        tabindex: 0,
        'focus-group': this.componentId
      };
    },
    bindedInputAttributes() {
      return {
        onfocus: this.onFocus,
        oninput: () => this.$nextTick(() => this.$emit('input', this.value)),
        disabled: this.disabled || this.isSelector && !this.searchInSelector,
        spellcheck: false,
        placeholder: this.computedPlaceholder,
        'focus-group': this.componentId
      };
    },
    isSelector() {
      return !!this.items?.length;
    },
    searchInSelector() {
      return this.items?.length > 5;
    },
    computedPlaceholder() {
      return this.placeholder ? this.$st(this.placeholder) : this.$st(this.isSelector ? this.focus && this.searchInSelector ? 'general.search' : 'general.select' : 'general.type_here');
    },
    computedValue: {
      get() {
        if (this.isSelector) {
          return this.searchInSelector ? this.search : undefined;
        } else return this.value;
      },
      set(value) {
        if (this.isSelector) {
          this.searchInSelector ? this.search = value : undefined;
        } else this.value = value;
      }
    },
    computedSearch() {
      return this.search.replaceAll(' ', '').toLowerCase();
    },
    filteredItemsBySearch() {
      if (!this.search) return this.items;
      const items_ = this.items?.filter(i => i.label.toString().replaceAll(' ', '').toLowerCase().includes(this.computedSearch));
      if (this.allButton && items_) {
        items_.unshift({
          label: 'Todo',
          click: () => this.value = undefined
        });
      }
      return items_;
    },
    selectedItems() {
      if (!this.isSelector) return;
      return this.items?.filter(i => this.multiple ? this.value.includes(i.value) : this.value !== undefined && i.value === this.value);
    },
    passwordLevel() {
      return this.PasswordLevel();
    }
  },
  created() {
    if (this.isSelector && this.multiple && !Array.isArray(this.value)) {
      this.value = [];
    }
    if (this.type === 'date' && this.value) {
      const date = new Date(this.value);
      if (isNaN(date.getTime())) {
        const splittedDate = this.value.split('/');
        this.value = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
      } else {
        this.value = date.toISOString().split('T')[0];
      }
    }
  },
  mounted() {
    if (this.autofocus) {
      this.$el.querySelector('input', 'textarea')?.focus();
    }
    if (this.prefix) this.$emit('update:prefix', this.prefix);
  },
  methods: {
    onFocus: function () {
      this.$emit('focus');
      this.focus = true;
      this.$handleFocusGroup(this.onComponentBlur);
    },
    handleItemClick: function (item) {
      const val = item?.value;
      if (this.disabled) {
        return;
      }
      if (item.click instanceof Function) {
        item.click();
      }
      if (this.multiple) {
        if (!this.value) this.value = [];
        const index = this.value.indexOf(val);
        if (index > -1) {
          this.value.splice(index, 1);
        } else if (this.multiple) {
          this.value.push(val);
        } else {
          this.value = [val];
        }
      } else {
        this.value = this.value === val ? undefined : val;
        this.focus = false;
      }
      this.$emit('input', this.value);
    },
    onComponentBlur: function () {
      this.focus = false;
      this.search = undefined;
    },
    IsSelected: function (item) {
      if (this.multiple) {
        return this.value?.includes(item.value);
      } else {
        return this.value !== undefined && item.value === this.value;
      }
    }
  }
};